import { render, staticRenderFns } from "./PersonsPage.vue?vue&type=template&id=1c355c91&scoped=true"
import script from "./PersonsPage.vue?vue&type=script&lang=js"
export * from "./PersonsPage.vue?vue&type=script&lang=js"
import style0 from "./PersonsPage.vue?vue&type=style&index=0&id=1c355c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c355c91",
  null
  
)

export default component.exports